import { render, staticRenderFns } from "./SingleProfilePage.vue?vue&type=template&id=0430db29&scoped=true&"
import script from "./SingleProfilePage.vue?vue&type=script&lang=js&"
export * from "./SingleProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./SingleProfilePage.vue?vue&type=style&index=0&id=0430db29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0430db29",
  null
  
)

export default component.exports